var map = {
	"./AcquaPanna.svg": 1988,
	"./Asahi.svg": 697,
	"./Belaire.svg": 6729,
	"./Bols.svg": 8633,
	"./Bulldog.svg": 2322,
	"./Delirium.svg": 5102,
	"./Elrecuerdo.svg": 6365,
	"./Espolon.svg": 3423,
	"./Glenfiddich.svg": 6540,
	"./GrandMarnier.svg": 8771,
	"./Grolsch.svg": 4289,
	"./Jagermeister.svg": 8789,
	"./Licor43.svg": 9705,
	"./Margherita.svg": 7859,
	"./Monkeyshoulder.svg": 3300,
	"./Montelobos.svg": 9139,
	"./Ocean.svg": 3367,
	"./Peroni.svg": 6624,
	"./Perrier.svg": 9402,
	"./PuertodeIndias.svg": 2693,
	"./SPellegrino.svg": 6321,
	"./Titos.svg": 9612,
	"./Torresella.svg": 9870,
	"./abasolo.svg": 9622,
	"./amaroangostura.svg": 8425,
	"./anchoreyes.svg": 5182,
	"./angosturabitters.svg": 9846,
	"./aromo.svg": 2213,
	"./avgvstvs.svg": 4109,
	"./caleuche.svg": 7971,
	"./cerveceria14.svg": 7327,
	"./chateaularteau.svg": 9922,
	"./chateausenilhac.svg": 7139,
	"./chinola.svg": 1135,
	"./cihuatan.svg": 320,
	"./cruzalba.svg": 2589,
	"./cuttysark.svg": 2573,
	"./dogma.svg": 2185,
	"./domainecanton.svg": 8289,
	"./drambuie-seeklogo-3.svg": 1770,
	"./elyucateco.svg": 8073,
	"./evanwilliams.svg": 2265,
	"./granmalo.svg": 436,
	"./grants.svg": 2650,
	"./hpnotiq.svg": 1876,
	"./lolea.svg": 9818,
	"./luxardo.svg": 1640,
	"./mahou.svg": 9307,
	"./marfrades.svg": 1290,
	"./martinmillers.svg": 5512,
	"./minuty.svg": 8547,
	"./nixta.svg": 4633,
	"./nuvo.svg": 1741,
	"./ojotigre.svg": 9246,
	"./pama.svg": 2016,
	"./ramonbilbao.svg": 9771,
	"./santamargherita.svg": 8610,
	"./stambecco.svg": 9680,
	"./suze.svg": 6340,
	"./tequilaocho.svg": 8525,
	"./terreliade.svg": 8670,
	"./theglenrothes.svg": 5257
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;